import { gql } from '@apollo/client';

export const addToWishlist = gql`
  mutation AddToWishlist($sku: [String!]!, $challenge: Challenge, $locale: Locale!) {
    wishlist: addArticlesToWishlist(sku: $sku, challenge: $challenge) {
      name
      articles(locale: $locale) {
        sku
      }
    }
  }
`;
